module.exports = __webpack_public_path__ + "static/media/BookIcon.86145e48.png";